<script setup>
import { RouterView } from 'vue-router'
import { storeCurrentSession } from "@/utils/cognito";
import { computed } from 'vue'
import { useRoute } from 'vue-router'

storeCurrentSession();
const route = useRoute()
const layout = computed(() => route.meta.layout || 'div')
</script>
<template>
  <component :is="layout">
    <transition name="router-animation" mode="out-in" appear>
     <RouterView />
    </transition>
  </component>
</template>

<style>
.router-animation-enter-active {
  animation: coming 0.2s;
  animation-delay: 0.1s;
  opacity: 0;
}
.router-animation-leave-active {
  animation: going 0.2s;
}

@keyframes going {
  from {
    /*transform: translate3d(0, 0, 0) scale(1);*/
  }
  to {
    /*transform: translate3d(0, 4%, 0) scale(0.93);*/
    opacity: 0;
  }
}
@keyframes coming {
  from {
    /*transform: translate3d(0, 4%, 0) scale(0.93);*/
    opacity: 0;
  }
  to {
    /*transform: translate3d(0, 0, 0) scale(1);*/
    opacity: 1;
  }
}

</style>
